/**
 * `inventory` translations, for every locale.
 *
 * `noOptions` is not a loading message. The brand and RAM lists ship EMPTY
 * because neither SharePoint list was exported and inventing values would put
 * brands nobody chose into an asset register. The string has to say that, or an
 * empty picker reads as a bug.
 */
export const inventory = {
  mn: {
    inventory: {
      section: 'Хөрөнгө', laptops: 'Компьютер',
      subtitle: 'Ямар компьютер байгаа, хэн хэрэглэж байгаа.',
      listLoadFailed: 'Компьютерийн жагсаалтыг ачаалж чадсангүй.', detailLoadFailed: 'Энэ компьютерийг ачаалж чадсангүй.',
      addFailed: 'Компьютер нэмж чадсангүй:', saveFailed: 'Компьютерийг хадгалж чадсангүй:',
      optionAddFailed: 'Сонголт нэмж чадсангүй:', optionSaveFailed: 'Сонголтыг хадгалж чадсангүй:', optionRemoveFailed: 'Сонголтыг хасаж чадсангүй:',
      handOverFailed: 'Компьютерийг хүлээлгэн өгч чадсангүй:', returnFailed: 'Компьютерийг буцааж авч чадсангүй:',
      add: 'Шинэ', newMachine: 'Нэргүй компьютер',
      search: 'Загвар, дугаар, хэрэглэгчээр хайх',
      loading: 'Ачаалж байна…', none: 'Бүртгэл алга', pick: 'Жагсаалтаас сонгоно уу',
      unnamed: 'Нэргүй', free: 'Сул', heldBy: '{{name}} хэрэглэж байна',
      saved: 'Хадгалагдлаа', readOnly: 'Танд өөрчлөх эрх алга.',
      noOptions: 'Утга нэмээгүй байна',
      addValue: 'Утга нэмэх', newValue: 'Шинэ утга',
      editValue: 'Утга засах', deactivateValue: 'Идэвхгүй болгох',
      valueRequired: 'Утгыг бичнэ үү', working: 'Хадгалж байна…',
      noHistory: 'Түүх алга', stillOut: 'Хэрэглэж байна', unknownHolder: 'Тодорхойгүй',
      tab: { history: 'Түүх', handover: 'Олгох' },
      field: {
        performance: 'Хүчин чадлын ангилал',
        asset_tag: 'Хөрөнгийн дугаар', model: 'Загвар', brand: 'Үйлдвэрлэгч',
        ram: 'Санах ой', cpu: 'Процессор', gpu: 'График', hard_disk_tb: 'Хатуу диск (ТБ)',
        status: 'Төлөв', manufactured_year: 'Үйлдвэрлэсэн он', bought_date: 'Авсан огноо',
        issues: 'Гэмтэл', comment: 'Тайлбар', details: 'Дэлгэрэнгүй',
      },
      kit: {
        mouse: 'Хулгана', flashdrive: 'Флаш диск', harddrive: 'Хатуу диск',
        converter: 'Хувиргагч', cooler_fan: 'Сэнс',
      },
      kitLegend: 'Хамт өгсөн зүйл',
      toProject: 'Төсөлд', project: 'Төсөл', projectRequired: 'Төслөө сонгоно уу', allClasses: 'Бүх ангилал',
      toEmployee: 'Ажилтан', orName: 'Эсвэл нэр', orNameHint: 'Гэрээт ажилтан, хүлээн авах',
      receiveDate: 'Хүлээлгэн өгсөн огноо', handoverStatus: 'Хүлээлгэн өгөх төлөв',
      note: 'Тэмдэглэл', handOver: 'Олгох', handedOver: 'Олголоо',
      takeBack: 'Буцаан авах', returned: 'Буцаан авлаа', newStatus: 'Шинэ төлөв',
      willReplace: 'Одоогийн хэрэглэгчийн бүртгэл хаагдана.',
      fixed: {
        search: 'Хөрөнгө хайх', allStatuses: 'Бүх төлөв', item: 'Зүйл', category: 'Ангилал', quantity: 'Тоо',
        status: 'Төлөв', place: 'Байршил', team: 'Баг', counted: 'Тоолсон',
        empty: 'Үндсэн хөрөнгө бүртгэгдээгүй байна', noMatch: '“{{search}}”-д тохирох зүйл алга',
        loadFailed: 'Үндсэн хөрөнгийг ачаалж чадсангүй', shown: '{{total}}-с {{shown}} мөр',
      },
      stock: {
        item: 'Зүйл', type: 'Төрөл', owned: 'Эзэмшиж буй', inUse: 'Хэрэглээнд', inStore: 'Агуулахад', requested: 'Хүссэн',
        kind: { roster: 'Хувцас хэрэгсэл', office: 'Оффис', merch: 'Нэрийн бүтээгдэхүүн', supply: 'Хангамжийн материал', laptop: 'Компьютер' },
        unclassified: 'Ангилаагүй', total: 'Нийт', search: 'Зүйл хайх',
        empty: 'Зүйл бүртгэгдээгүй байна', noMatch: '“{{search}}”-д тохирох зүйл алга',
        loadFailed: 'Нөөцийг ачаалж чадсангүй.', noSingleDefaultIssuer: 'Нөөцөд яг нэг «Үндсэн гаргагч» шаардлагатай. Байгууллага хэсэгт нэг компанид үүнийг сонгоод дахин оролдоно уу.', saveFailed: 'Нөөцийг хадгалж чадсангүй:', saved: 'Хадгаллаа',
        invalid: '0-ээс {{max}} хүртэлх бүхэл тоо', short: 'Эзэмшиж буйгаас {{count}}-ээр илүү хэрэглээнд байна',
        laptopOwned: 'Хасагдаагүй компьютерээс тоологдоно',
        splitOwned: 'Компани, размер эсвэл байршлаар тоологдсон тул нэг тоогоор засах боломжгүй',
        editOwned: '{{item}}: эзэмшиж буй',
      },
      register: {
        appoint: { kind: { assets: 'Хөрөнгө', stock: 'Нөөц', accounts: 'Бүртгэл', oreas: 'OREAS' }, person: 'Хүн', search: 'Хүн хайх', add: 'Гэрээт ажилтан нэмэх', addPick: 'Хүн сонгох', addNone: 'Нэмэх хүн алга', toggle: '{{name}}: {{type}}', saveFailed: '{{name}}-н {{type}} эрхийг хадгалж чадсангүй.', loadFailed: 'Томилгоог ачаалж чадсангүй.', empty: 'Хайлтад тохирох хүн алга.' },
        view: { stock: 'Нөөц', fixed: 'Үндсэн хөрөнгө', laptops: 'Компьютер', office: 'Оффисын хэрэгсэл', field: 'Хувцас хэрэгсэл', people: 'Хүнээр', accounts: 'Бүртгэл', appoint: 'Томилгоо' },
        gear: 'Хувцас хэрэгсэл',
        toProject: 'Төсөлд олгох', project: 'Төсөл', projectRequired: 'Төслөө сонгоно уу', projectTag: 'Төсөл',
        help: {
          appoint: 'Төрөл бүрийг хэн засахыг заана. Бүх үндсэн ажилтан Хөрөнгийг харна; тэмдэглэгээтэй хүн тухайн төрлийг засаж, хүсэлтэд нь хариулна.',
          stock: 'Зүйл бүрээр: эзэмшиж буй, хэрэглээнд, агуулахад, хүсэлтээр хүссэн тоо.',
          fixed: 'Компанийн эзэмшдэг эд зүйлс: төлөв, байршил, хариуцах баг. Зөвхөн харах.',
          accounts: 'Компанийн гадны платформ дээрх бүртгэлүүд: платформ бүрээр хэдэн бүртгэл, хэн эзэмшдэг.',
          laptops: 'Бүх компьютер, хэн эзэмшиж буй, түүх. Нэгийг сонгож хүлээлгэн өгөх эсвэл буцааж авна.',
          office: 'Ажилтан бүрт олгосон оффисын хэрэгсэл. Нүдэн дээр дарж засах эсвэл олгоно.',
          field: 'Ажилтан бүрт олгосон ажлын хувцас, гутал, хантааз. Нүдэн дээр дарж засах эсвэл олгоно.',
          people: 'Нэг хүний одоо эзэмшиж буй бүх зүйл: компьютер ба хэрэгсэл.',
        },
        item: {
          bag: 'Цүнх',
          tumbler: 'Термос аяга',
          locker: 'Шүүгээ',
          pouch: 'Жижиг цүнх',
          umbrella: 'Шүхэр',
          notebook: 'Дэвтэр',
          converter: 'Хувиргагч',
          mouse: 'Хулгана',
          rolling_cabinet: 'Дугуйтай шүүгээ',
          flash_drive: 'Флаш диск',
          hard_drive: 'Хатуу диск',
          tablet: 'Таблет',
          cooler: 'Компьютерийн сэрүүцүүлэгч',
          sport_wear: 'Спорт хувцас',
          vest: 'Хантааз',
          work_wear_summer: 'Ажлын хувцас (зун)',
          work_wear_winter: 'Ажлын хувцас (өвөл)',
          work_boots_summer: 'Ажлын гутал (зун)',
          work_boots_winter: 'Ажлын гутал (өвөл)',
          helmet: 'Каск',
          cup: 'Аяга',
          field_bag: 'Цүнх',
        },
        search: 'Нэрээр хайх',
        name: 'Нэр',
        issue: 'Олгох',
        issueTitle: 'Хэрэгсэл олгох',
        person: 'Ажилтан',
        itemType: 'Хэрэгсэл',
        variant: 'Хэмжээ эсвэл дугаар',
        issuedOn: 'Олгосон огноо',
        returnedOn: 'Буцаасан огноо',
        note: 'Тэмдэглэл',
        held: 'Эзэмшиж байна',
        notHeld: 'Олгоогүй',
        sizeClothes: 'Хувцас',
        sizeBoots: 'Гутал',
        sizesTitle: 'Размер: {{name}}',
        sizesEdit: '{{name}}-ийн размер',
        sizesAdd: '{{name}}-д размер нэмэх',
        sizesHint: 'Хоёуланг нь хоосон үлдээвэл размер устна.',
        sizesSaveFailed: 'Размер хадгалж чадсангүй.',
        filterOf: '{{item}} шүүлтүүр',
        filterAny: 'Бүгд',
        filterHas: 'Олгосон',
        filterHasNot: 'Олгоогүй',
        filterUnknown: 'Тодорхойгүй',
        filterClear: 'Шүүлтүүрийг арилгах',
        noFilterMatch: 'Шүүлтүүрт тохирох мөр алга.',
        export: 'Excel татах',
        exportIssued: 'олгосон',
        exportSheetField: 'Хувцас хэрэгсэл',
        exportSheetOffice: 'Оффисын хэрэгсэл',
        markReturned: 'Буцаасан гэж тэмдэглэх',
        returnedDone: 'Буцаасан гэж тэмдэглэлээ',
        issued: 'Олголоо',
        editTitle: '{{name}}: {{item}}',
        empty: 'Энд хэн ч юу ч эзэмшээгүй байна',
        noMatch: '“{{search}}” нэртэй хүн алга',
        loadFailed: 'Олгосон хэрэгслийг ачаалж чадсангүй.',
        typesLoadFailed: 'Хэрэгслийн төрлийг ачаалж чадсангүй.',
        issueFailed: 'Хэрэгсэл олгож чадсангүй:',
        saveFailed: 'Хэрэгслийг хадгалж чадсангүй:',
        returnFailed: 'Буцаалтыг тэмдэглэж чадсангүй:',
        personRequired: 'Хэнд олгохыг сонгоно уу',
        itemRequired: 'Хэрэгслийг сонгоно уу',
        returnBeforeIssue: 'Буцаасан огноо нь олгосон огнооноос ({{date}}) өмнө байна.',
        pickPerson: 'Жагсаалтаас хүн сонгоно уу',
       
        returned: 'Буцаасан',
        holdsNothing: 'Юу ч эзэмшээгүй', myKitHint: 'Танд олгосон хэрэгсэл, ажлын хувцас "Хэрэгсэл" хэсэгт байна.',
        laptops: 'Компьютер',
        items: 'Хэрэгсэл',
      },
    },
  },
  en: {
    inventory: {
      section: 'Inventory', laptops: 'Laptops',
      subtitle: 'What machines the company has, and who is holding them.',
      listLoadFailed: 'Could not load the machines.', detailLoadFailed: 'Could not load this machine.',
      addFailed: 'Could not add the machine:', saveFailed: 'Could not save the machine:',
      optionAddFailed: 'Could not add the option:', optionSaveFailed: 'Could not save the option:', optionRemoveFailed: 'Could not remove the option:',
      handOverFailed: 'Could not hand the machine over:', returnFailed: 'Could not take the machine back:',
      add: 'Add', newMachine: 'Unnamed machine',
      search: 'Search model, tag or holder',
      loading: 'Loading…', none: 'Nothing registered', pick: 'Pick a machine from the list',
      unnamed: 'Unnamed', free: 'Not issued', heldBy: 'Held by {{name}}',
      saved: 'Saved', readOnly: 'You do not have permission to change this.',
      noOptions: 'No values added yet',
      addValue: 'Add a value', newValue: 'New value',
      editValue: 'Edit value', deactivateValue: 'Deactivate',
      valueRequired: 'Type a value first', working: 'Working…',
      noHistory: 'No hand-overs recorded', stillOut: 'still out', unknownHolder: 'Unrecorded',
      tab: { history: 'History', handover: 'Hand over' },
      field: {
        performance: 'Performance class',
        asset_tag: 'Asset tag', model: 'Model', brand: 'Brand',
        ram: 'RAM', cpu: 'CPU', gpu: 'GPU', hard_disk_tb: 'Hard disk (TB)',
        status: 'Status', manufactured_year: 'Year made', bought_date: 'Bought',
        issues: 'Issues', comment: 'Comment', details: 'Details',
      },
      kit: {
        mouse: 'Mouse', flashdrive: 'Flash drive', harddrive: 'Hard drive',
        converter: 'Converter', cooler_fan: 'Cooler fan',
      },
      kitLegend: 'Handed over with it',
      toProject: 'To a project', project: 'Project', projectRequired: 'Choose the project', allClasses: 'All classes',
      toEmployee: 'To employee', orName: 'Or a name', orNameHint: 'Contractor, reception spare…',
      receiveDate: 'Received on', handoverStatus: 'Hand-over status',
      note: 'Note', handOver: 'Hand over', handedOver: 'Handed over',
      takeBack: 'Take back', returned: 'Taken back', newStatus: 'New status',
      willReplace: 'This closes the current holder’s record.',
      fixed: {
        search: 'Search assets', allStatuses: 'All statuses', item: 'Item', category: 'Category', quantity: 'Qty',
        status: 'Status', place: 'Place', team: 'Team', counted: 'Counted',
        empty: 'No fixed assets yet', noMatch: 'Nothing matches “{{search}}”',
        loadFailed: 'Could not load the fixed assets', shown: '{{shown}} of {{total}} lines',
      },
      stock: {
        item: 'Item', type: 'Type', owned: 'Owned', inUse: 'In use', inStore: 'In store', requested: 'Requested',
        kind: { roster: 'Gear', office: 'Office', merch: 'Merch', supply: 'Supplies', laptop: 'Laptop' },
        unclassified: 'Not classified', total: 'Total', search: 'Search an item',
        empty: 'No items registered yet', noMatch: 'No item matches “{{search}}”',
        loadFailed: 'Could not load the stock.', noSingleDefaultIssuer: 'Stock needs exactly one Default issuer. Tick it on one company under Organization, then try again.', saveFailed: 'Could not save the stock:', saved: 'Saved',
        invalid: 'A whole number from 0 to {{max}}', short: '{{count}} more in use than owned',
        laptopOwned: 'Counted from the laptops that are not retired',
        splitOwned: 'Counted per company, size or place, so it cannot be set as one number',
        editOwned: '{{item}}: owned',
      },
      register: {
        appoint: { kind: { assets: 'Assets', stock: 'Stock', accounts: 'Accounts', oreas: 'OREAS' }, person: 'Person', search: 'Search people', add: 'Add a contractor', addPick: 'Pick a person', addNone: 'Nobody else to add', toggle: '{{type}} for {{name}}', saveFailed: 'Could not save {{type}} for {{name}}.', loadFailed: 'Could not load the appointments.', empty: 'Nobody matches this search.' },
        view: { stock: 'Stock', fixed: 'Fixed assets', laptops: 'Laptops', office: 'Office kit', field: 'Gear', people: 'By person', accounts: 'Accounts', appoint: 'Appoint' },
        gear: 'Gear',
        toProject: 'To a project', project: 'Project', projectRequired: 'Choose the project', projectTag: 'Project',
        help: {
          appoint: 'Who may edit each type. Every Full Time employee reads Inventory; a tick lets someone write that type and answer its requests.',
          stock: 'Per item: how many are owned, in use, in store and asked for in open requests.',
          fixed: 'What the company owns: status, place and the team in charge. Read only.',
          accounts: 'The company’s accounts on outside platforms: how many per platform and who holds them.',
          laptops: 'Every laptop, who holds it and its history. Pick one to hand it over or take it back.',
          office: 'Office kit handed to each person. Click a cell to edit it or to issue the item.',
          field: 'Work wear, boots and vests handed to each person. Click a cell to edit it or to issue the item.',
          people: 'Everything one person holds now: laptops and kit.',
        },
        item: {
          bag: 'Bag',
          tumbler: 'Tumbler',
          locker: 'Locker',
          pouch: 'Pouch',
          umbrella: 'Umbrella',
          notebook: 'Notebook',
          converter: 'Converter',
          mouse: 'Mouse',
          rolling_cabinet: 'Rolling cabinet',
          flash_drive: 'Flash drive',
          hard_drive: 'Hard drive',
          tablet: 'Tablet',
          cooler: 'Laptop cooler',
          sport_wear: 'Sport wear',
          vest: 'Vest',
          work_wear_summer: 'Work wear (summer)',
          work_wear_winter: 'Work wear (winter)',
          work_boots_summer: 'Work boots (summer)',
          work_boots_winter: 'Work boots (winter)',
          helmet: 'Helmet',
          cup: 'Cup',
          field_bag: 'Bag',
        },
        search: 'Search a name',
        name: 'Name',
        issue: 'Hand over',
        issueTitle: 'Hand over an item',
        person: 'Person',
        itemType: 'Item',
        variant: 'Size or number',
        issuedOn: 'Handed over on',
        returnedOn: 'Returned on',
        note: 'Note',
        held: 'Held',
        notHeld: 'Not issued',
        sizeClothes: 'Clothes',
        sizeBoots: 'Boots',
        sizesTitle: 'Sizes: {{name}}',
        sizesEdit: 'Sizes of {{name}}',
        sizesAdd: 'Add sizes for {{name}}',
        sizesHint: 'Leave both blank to remove the sizes.',
        sizesSaveFailed: 'Could not save the sizes.',
        filterOf: 'Filter {{item}}',
        filterAny: 'All',
        filterHas: 'Handed over',
        filterHasNot: 'Not issued',
        filterUnknown: 'Not known',
        filterClear: 'Clear filters',
        noFilterMatch: 'No row matches the filters.',
        export: 'Export to Excel',
        exportIssued: 'handed over',
        exportSheetField: 'Gear',
        exportSheetOffice: 'Office kit',
        markReturned: 'Mark returned',
        returnedDone: 'Marked returned',
        issued: 'Handed over',
        editTitle: '{{name}}: {{item}}',
        empty: 'Nobody holds anything here yet',
        noMatch: 'Nobody matches “{{search}}”',
        loadFailed: 'Could not load the issued items.',
        typesLoadFailed: 'Could not load the item types.',
        issueFailed: 'Could not issue the item:',
        saveFailed: 'Could not save the item:',
        returnFailed: 'Could not mark the item returned:',
        personRequired: 'Choose who gets it',
        itemRequired: 'Choose the item',
        returnBeforeIssue: 'The return date is before the issue date ({{date}}).',
        pickPerson: 'Pick a person from the list',
       
        returned: 'Returned',
        holdsNothing: 'Holds nothing', myKitHint: 'Kit and work wear handed to you are listed under Items.',
        laptops: 'Laptops',
        items: 'Items',
      },
    },
  },
  ru: {
    inventory: {
      section: 'Инвентарь', laptops: 'Ноутбуки',
      subtitle: 'Какие машины есть у компании и у кого они на руках.',
      listLoadFailed: 'Не удалось загрузить список машин.', detailLoadFailed: 'Не удалось загрузить эту машину.',
      addFailed: 'Не удалось добавить машину:', saveFailed: 'Не удалось сохранить машину:',
      optionAddFailed: 'Не удалось добавить вариант:', optionSaveFailed: 'Не удалось сохранить вариант:', optionRemoveFailed: 'Не удалось убрать вариант:',
      handOverFailed: 'Не удалось передать машину:', returnFailed: 'Не удалось вернуть машину:',
      add: 'Добавить', newMachine: 'Без названия',
      search: 'Поиск по модели, номеру или держателю',
      loading: 'Загрузка…', none: 'Ничего не зарегистрировано', pick: 'Выберите машину из списка',
      unnamed: 'Без названия', free: 'Не выдан', heldBy: 'У {{name}}',
      saved: 'Сохранено', readOnly: 'У вас нет прав на изменение.',
      noOptions: 'Значения ещё не добавлены',
      addValue: 'Добавить значение', newValue: 'Новое значение',
      editValue: 'Изменить значение', deactivateValue: 'Деактивировать',
      valueRequired: 'Сначала введите значение', working: 'Выполняется…',
      noHistory: 'Выдач не зафиксировано', stillOut: 'на руках', unknownHolder: 'Не указан',
      tab: { history: 'История', handover: 'Выдача' },
      field: {
        performance: 'Класс производительности',
        asset_tag: 'Инвентарный номер', model: 'Модель', brand: 'Производитель',
        ram: 'Память', cpu: 'Процессор', gpu: 'Видеокарта', hard_disk_tb: 'Диск (ТБ)',
        status: 'Статус', manufactured_year: 'Год выпуска', bought_date: 'Куплен',
        issues: 'Неисправности', comment: 'Комментарий', details: 'Подробности',
      },
      kit: {
        mouse: 'Мышь', flashdrive: 'Флешка', harddrive: 'Жёсткий диск',
        converter: 'Переходник', cooler_fan: 'Подставка с вентилятором',
      },
      kitLegend: 'Выдано вместе с машиной',
      toProject: 'Проекту', project: 'Проект', projectRequired: 'Выберите проект', allClasses: 'Все классы',
      toEmployee: 'Сотруднику', orName: 'Или имя', orNameHint: 'Подрядчик, ресепшн…',
      receiveDate: 'Дата выдачи', handoverStatus: 'Статус выдачи',
      note: 'Примечание', handOver: 'Выдать', handedOver: 'Выдано',
      takeBack: 'Принять обратно', returned: 'Принято', newStatus: 'Новый статус',
      willReplace: 'Запись текущего держателя будет закрыта.',
      fixed: {
        search: 'Поиск имущества', allStatuses: 'Все статусы', item: 'Предмет', category: 'Категория', quantity: 'Кол-во',
        status: 'Статус', place: 'Место', team: 'Команда', counted: 'Пересчитано',
        empty: 'Основных средств пока нет', noMatch: 'Ничего не найдено по «{{search}}»',
        loadFailed: 'Не удалось загрузить основные средства', shown: '{{shown}} из {{total}} строк',
      },
      stock: {
        item: 'Предмет', type: 'Тип', owned: 'Есть', inUse: 'В работе', inStore: 'На складе', requested: 'Запрошено',
        kind: { roster: 'Снаряжение', office: 'Офис', merch: 'Фирменная продукция', supply: 'Расходные материалы', laptop: 'Ноутбук' },
        unclassified: 'Без класса', total: 'Итого', search: 'Найти предмет',
        empty: 'Предметов пока нет', noMatch: 'Нет предметов по запросу «{{search}}»',
        loadFailed: 'Не удалось загрузить запас.', noSingleDefaultIssuer: 'Для запаса нужен ровно один «Эмитент по умолчанию». Отметьте его у одной компании в разделе «Организация» и повторите попытку.', saveFailed: 'Не удалось сохранить запас:', saved: 'Сохранено',
        invalid: 'Целое число от 0 до {{max}}', short: 'В работе на {{count}} больше, чем есть',
        laptopOwned: 'Считается по ноутбукам, которые не списаны',
        splitOwned: 'Учтено по компаниям, размерам или местам, поэтому одним числом не задаётся',
        editOwned: '{{item}}: есть',
      },
      register: {
        appoint: { kind: { assets: 'Имущество', stock: 'Запас', accounts: 'Аккаунты', oreas: 'OREAS' }, person: 'Сотрудник', search: 'Поиск сотрудника', add: 'Добавить подрядчика', addPick: 'Выберите сотрудника', addNone: 'Больше некого добавить', toggle: '{{type}}: {{name}}', saveFailed: 'Не удалось сохранить {{type}} для {{name}}.', loadFailed: 'Не удалось загрузить назначения.', empty: 'По этому поиску никого нет.' },
        view: { stock: 'Запас', fixed: 'Основные средства', laptops: 'Ноутбуки', office: 'Офисные вещи', field: 'Снаряжение', people: 'По сотруднику', accounts: 'Аккаунты', appoint: 'Назначения' },
        gear: 'Снаряжение',
        toProject: 'Проекту', project: 'Проект', projectRequired: 'Выберите проект', projectTag: 'Проект',
        help: {
          appoint: 'Кто может редактировать каждый тип. Инвентарь видят все штатные сотрудники; отметка даёт право редактировать тип и отвечать на его заявки.',
          stock: 'По каждому предмету: сколько есть, в работе, на складе и запрошено в открытых заявках.',
          fixed: 'Имущество компании: статус, место и ответственная команда. Только просмотр.',
          accounts: 'Аккаунты компании на внешних платформах: сколько на каждой и у кого они.',
          laptops: 'Все ноутбуки, у кого они и их история. Выберите ноутбук, чтобы передать или принять его.',
          office: 'Офисные вещи, выданные каждому сотруднику. Нажмите на ячейку, чтобы изменить или выдать.',
          field: 'Рабочая одежда, обувь и жилеты, выданные каждому. Нажмите на ячейку, чтобы изменить или выдать.',
          people: 'Всё, что сейчас у одного сотрудника: ноутбуки и вещи.',
        },
        item: {
          bag: 'Сумка',
          tumbler: 'Термокружка',
          locker: 'Шкафчик',
          pouch: 'Чехол',
          umbrella: 'Зонт',
          notebook: 'Блокнот',
          converter: 'Переходник',
          mouse: 'Мышь',
          rolling_cabinet: 'Тумба на колёсах',
          flash_drive: 'Флешка',
          hard_drive: 'Жёсткий диск',
          tablet: 'Планшет',
          cooler: 'Охлаждающая подставка',
          sport_wear: 'Спортивная форма',
          vest: 'Жилет',
          work_wear_summer: 'Рабочая одежда (лето)',
          work_wear_winter: 'Рабочая одежда (зима)',
          work_boots_summer: 'Рабочая обувь (лето)',
          work_boots_winter: 'Рабочая обувь (зима)',
          helmet: 'Каска',
          cup: 'Кружка',
          field_bag: 'Сумка',
        },
        search: 'Поиск по имени',
        name: 'Имя',
        issue: 'Выдать',
        issueTitle: 'Выдать вещь',
        person: 'Сотрудник',
        itemType: 'Вещь',
        variant: 'Размер или номер',
        issuedOn: 'Выдано',
        returnedOn: 'Возвращено',
        note: 'Примечание',
        held: 'На руках',
        notHeld: 'Не выдано',
        sizeClothes: 'Одежда',
        sizeBoots: 'Обувь',
        sizesTitle: 'Размеры: {{name}}',
        sizesEdit: 'Размеры: {{name}}',
        sizesAdd: 'Добавить размеры для {{name}}',
        sizesHint: 'Оставьте оба поля пустыми, чтобы удалить размеры.',
        sizesSaveFailed: 'Не удалось сохранить размеры.',
        filterOf: 'Фильтр: {{item}}',
        filterAny: 'Все',
        filterHas: 'Выдано',
        filterHasNot: 'Не выдано',
        filterUnknown: 'Не известно',
        filterClear: 'Сбросить фильтры',
        noFilterMatch: 'Нет строк, подходящих под фильтры.',
        export: 'Выгрузить в Excel',
        exportIssued: 'выдано',
        exportSheetField: 'Снаряжение',
        exportSheetOffice: 'Офисные вещи',
        markReturned: 'Отметить возврат',
        returnedDone: 'Возврат отмечен',
        issued: 'Выдано',
        editTitle: '{{name}}: {{item}}',
        empty: 'Здесь пока ничего не выдано',
        noMatch: 'Никто не найден по «{{search}}»',
        loadFailed: 'Не удалось загрузить выданные вещи.',
        typesLoadFailed: 'Не удалось загрузить типы вещей.',
        issueFailed: 'Не удалось выдать вещь:',
        saveFailed: 'Не удалось сохранить вещь:',
        returnFailed: 'Не удалось отметить возврат:',
        personRequired: 'Выберите, кому выдать',
        itemRequired: 'Выберите вещь',
        returnBeforeIssue: 'Дата возврата раньше даты выдачи ({{date}}).',
        pickPerson: 'Выберите сотрудника из списка',
       
        returned: 'Возвращено',
        holdsNothing: 'Ничего нет на руках', myKitHint: 'Выданные вам вещи и рабочая одежда — в разделе «Вещи».',
        laptops: 'Ноутбуки',
        items: 'Вещи',
      },
    },
  },
}
